import 'core-js/modules/es6.array.from.js';
import Vue from 'vue'
import Slideshow from './Slideshow.vue'

import Offices from './Offices.vue'

for (var index in window.lazySlideShow) {
    new Vue({
	el: window.lazySlideShow[index].el,
	render: h => h(Slideshow, {props: {initialSlides: window.lazySlideShow[index].slides}})
    })    
}


for (var index in window.lazyOffices) {
    new Vue({
	el: window.lazyOffices[index].el,
	render: h => h(Offices, {props: {offices: window.lazyOffices[index].slides}})
    })    
}


import 'lazysizes'
require('lazysizes/plugins/object-fit/ls.object-fit.js');



